export default {
  'profile.personalinfo.title.label': 'Fampahalalana manokana',
  'profile.jobinfo.title.label': "Momban'ny asa",
  'profile.healthinfo.title.label': 'Fampahalalana momba ny fahasalamana ',
  'profile.healthinfo.vaccine.dose.label': 'Dose {doseNum}',
};
